import React from 'react';
import ButtonModal from './ButtonModal';
import PropTypes from 'prop-types';
import { WarningAmber } from '@mui/icons-material';

const ConfirmationModal = ({
  type,
  name,
  toggleModal, 
  confirmConfirmation,
  messagesCount
}) => {
  return (
    <>
      <div className='fixed z-10 inset-0 overflow-y-auto '>
        <div className='absolute w-full h-full bg-gray opacity-50'></div>
        <div className='flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0'>
          <div className='fixed inset-0 transition-opacity' aria-hidden='true'>
            <div className='absolute inset-0 bg-gray-500 opacity-75'></div>
          </div>

          <span className='hidden sm:inline-block sm:h-screen' aria-hidden='true'>
            &#8203;
          </span>

          <div
            className='inline-block align-bottom bg-gray-50 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full'
            role='dialog'
            aria-modal='true'
            aria-labelledby='modal-headline'
          >
            <div className='bg-gray-lighter50 px-4 pt-5 pb-4 sm:p-6 sm:pb-4'>
              <div className='sm:flex sm:items-start'>
                <div className='mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left'>
                    <h3
                      className='text-lg leading-6 font-bold text-gray-900'
                      id='modal-headline'
                    >
                    {/* {messagesCount} */
                      messagesCount > 0 
                      ? <>
                        <WarningAmber fontSize='large' sx={{mr: 1}}/>
                          You have already sent ({messagesCount}) <span style={{'fontStyle': 'italic'}}>{type}</span> messages to the customer.
                        <div>
                          <h3 className='text-lg leading-6 font-bold text-gray-900 mt-2 mb-0'>Are you sure you want to send another one?</h3>
                        </div>
                      </>
                      : <>
                          Are you sure you want to send a <span style={{fontStyle: 'italic'}}>{type}</span> message to <span style={{fontStyle: 'italic'}}>{name}</span>?
                        </>
                    }
                    
                  </h3>
                </div>
              </div>
            </div>
            <div className='bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row justify-around'>
              <ButtonModal toggleModal={toggleModal} confirmConfirmation={confirmConfirmation}></ButtonModal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ConfirmationModal.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  toggleModal: PropTypes.func,
  confirmConfirmation: PropTypes.func,
  messagesCount: PropTypes.number
}

export default ConfirmationModal;
